import { Button } from "@mui/material";
import { useFormik } from "formik";
import {
  NEW_PATIENT_INITIAL_VALUES,
  NEW_PATIENT_VALIDATION_SCHEMA,
  NewPatientType,
} from "../../../../constants/scheduling";
import { useSnackbar } from "../../../../hooks/useSnackbar";
import { getErrorSnackbar, getSuccessSnackbar } from "../../../../utils/utils";
import SideSheetDrawer from "../../../SidesheetDrawer";
import PatientRegistrationGenericForm from "./PatientRegistrationGenericForm";
import Flex from "../../../Flex";

interface NewPatientProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (values: NewPatientType) => Promise<any>;
}

const NewPatient = ({ open, onClose, onSubmit }: NewPatientProps) => {
  const showSnackbar = useSnackbar();
  const formik = useFormik({
    initialValues: NEW_PATIENT_INITIAL_VALUES,
    validationSchema: NEW_PATIENT_VALIDATION_SCHEMA,
    onSubmit: (values) => {
      const date = new Date(values.birthDate);
      date.setHours(0, 0, 0, 0);

      onSubmit({
        ...values,
        birthDate: date.toISOString(),
      })
        ?.then((res) => {
          showSnackbar(getSuccessSnackbar(res));
          formik.resetForm();
          setTimeout(onClose, 2000);
        })
        .catch((err) => {
          showSnackbar(getErrorSnackbar(err));
        });
    },
  });

  return (
    <SideSheetDrawer
      open={open}
      onClose={() => {
        formik.resetForm();
        onClose();
      }}
      title="New Patient"
      w="900px"
      footerActions={
        <Button
          size="large"
          variant="contained"
          onClick={() => formik.handleSubmit()}
        >
          Add
        </Button>
      }
    >
      <Flex flexDirection={"column"}>
        <PatientRegistrationGenericForm formik={formik} />
      </Flex>
    </SideSheetDrawer>
  );
};

export default NewPatient;
